import React from 'react';
import Icon from '@mdi/react';

import {
  mdiBattery90,
  mdiCloudArrowDown,
  mdiGauge,
  mdiHydraulicOilLevel,
  mdiLightningBolt,
  mdiLockOpenAlert,
  mdiPowerPlugBattery,
  mdiSpeedometer,
  mdiSprout,
  mdiThermometer,
  mdiThermometerLines,
  mdiTree,
  mdiVolumeHigh,
  mdiWater,
  mdiWaterPercent,
  mdiWavesArrowUp,
  mdiWeatherPouring,
  mdiWeatherWindy,
  mdiWindsock,
} from '@mdi/js';

const SENSOR_ICONS = {
  ambient_humidity: mdiWaterPercent,
  anemometer: mdiWeatherWindy,
  atmospheric_pressure: mdiCloudArrowDown,
  counter: mdiGauge,
  dendrometer: mdiTree,
  float_switch: mdiHydraulicOilLevel,
  intrusion: mdiLockOpenAlert,
  pressure: mdiSpeedometer,
  radar_level: mdiWavesArrowUp,
  rain_gauge: mdiWeatherPouring,
  temperature: mdiThermometerLines,
  wind_direction: mdiWindsock,
  generic_voltage: mdiLightningBolt,
  noise_level: mdiVolumeHigh,
  internal_battery: mdiBattery90,
  external_power: mdiPowerPlugBattery,
};

const FALLBACK_ICON = mdiGauge;

function SoilMoistureIcon() {
  return (
    <span
      className="
        sensor-visual-icon__composition
        sensor-visual-icon__composition--soil-moisture
      "
      aria-hidden="true"
    >
      <Icon
        path={mdiSprout}
        className="sensor-visual-icon__sprout"
      />

      <Icon
        path={mdiWater}
        className="sensor-visual-icon__drop"
      />
    </span>
  );
}

function SoilTemperatureIcon() {
  return (
    <span
      className="
        sensor-visual-icon__composition
        sensor-visual-icon__composition--soil-temperature
      "
      aria-hidden="true"
    >
      <Icon
        path={mdiSprout}
        className="sensor-visual-icon__sprout"
      />

      <Icon
        path={mdiThermometerLines}
        className="sensor-visual-icon__thermometer"
      />
    </span>
  );
}

function SensorVisualIcon({ visualType }) {
  if (visualType === 'soil_moisture') {
    return <SoilMoistureIcon />;
  }

  if (visualType === 'soil_temperature') {
    return <SoilTemperatureIcon />;
  }

  const icon = SENSOR_ICONS[visualType] || FALLBACK_ICON;
  const visualClass = visualType || 'fallback';

  return (
    <span
      className={`sensor-visual-icon sensor-visual-icon--${visualClass}`}
      aria-hidden="true"
    >
      <Icon
        path={icon}
        className="sensor-visual-icon__svg"
      />
    </span>
  );
}

export default SensorVisualIcon;